import { Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import ApplicationBar from './ApplicationBar';
import Layout from '../util/Layout';
import { ZENDESK_AUTH_CHANNEL, ZENDESK_AUTH_CLOSE_MESSAGE } from '../../../features/auth/AuthConsts';

const useStyles = makeStyles(() => createStyles({
  paper: {
    textAlign: 'center',
    paddingTop: 200,
    paddingBottom: 200,
  },
  text: {
    paddingBottom: 20,
  },
}));

export default function Auth() {
  const classes = useStyles();

  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');

  React.useEffect(() => {
    const channel = new BroadcastChannel(ZENDESK_AUTH_CHANNEL);
    channel.onmessage = (evt) => {
      if (evt.data === ZENDESK_AUTH_CLOSE_MESSAGE) {
        window.close();
      }
    };
    channel.postMessage(code);
    return () => {
      channel.close();
    };
  }, [code]);

  return (
    <ApplicationBar>
      <Layout>
        <div className={classes.paper}>
          <Typography className={classes.text} component="h1" variant="h3">
            If you see this page, this means something went wrong trying to login. Close the window and retry.
          </Typography>
        </div>
      </Layout>
    </ApplicationBar>
  );
}
